let mapper_options = {
  endpoint: 'digital_assets/eligibility/criteria',
  recordClass: require('./record')
}

module.exports = (store) => {
  store.defineMapper('eligibility_criteria', mapper_options)
}
